export const BUILD_BADGE = "build-2026-10-29-214436";
